import React from 'react'

export function ThemedComponent (WrappedComponent) {
  function getDisplayName (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component'
  }

  class ThemedHOC extends WrappedComponent {
    getThemeStyle () {
      const style = {}
      if (this.props.theme) {
        Object.keys(this.props.theme).forEach((key) => {
          const cssKey = `--${key}`
          const cssValue = this.props.theme && this.props.theme[key]

          if (cssValue) {
            style[cssKey] = cssValue
          }
        })
      }
      return style
    }

    render () {
      const elementsTree = super.render()
      const props = Object.assign({}, elementsTree.props)
      props.style = Object.assign({}, elementsTree.props.style, this.getThemeStyle())
      return React.cloneElement(elementsTree, props, elementsTree.props.children)
    }
  }

  ThemedHOC.displayName = `ThemedComponent(${getDisplayName(WrappedComponent)})`

  return ThemedHOC
}
